import styled from "styled-components";

export const Container = styled.div<{ color: string; selected?: boolean }>`
  width: 40px;
  height: 40px;
  position: relative;
  border-radius: 100%;
  background-color: ${({ color }) => color};

  opacity: 0.92;
  cursor: pointer;
  z-index: ${({ selected }) => (selected ? 100 : 1)};

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
  }

  &:before {
    content: "";
    width: 20px;
    height: 20px;
    position: absolute;
    background-color: ${({ color }) => color};
    z-index: -1;

    bottom: -3px;
    left: 50%;
    transform: translate(-50%, 0) rotate(45deg);
  }
`;

export const CenterContainer = styled.div`
  width: 75%;
  height: 75%;
  border-radius: 45px;
  background-color: lightpink;

  display: flex;
  align-items: center;
  justify-content: center;
`;
